module.exports = __webpack_public_path__ + "26f1e68dfbd8b8621e5d07f75571a1f9.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/LightItalic/OpenSans-LightItalic.ttf?v=1.1.0
// module id = 980
// module chunks = 0